export default {
  data () {
    return {
      swipePointZero: 0,
      swipeStyles: {},
    }
  },

  emits: [
    'close',
  ],

  methods: {
    touchStart (event) {
      this.swipePointZero = event.changedTouches[0].clientY
    },

    movingHandler (event) {
      const clientY = event.changedTouches[0].clientY
      if (!this.$refs.swipeHandle) return
      const wrapperYOffset = this.$refs.swipeHandle.offsetTop + (this.swipePointZero - this.$refs.swipeHandle.offsetTop)
      // let wrapperYOffset = this.$refs.swipeHandle.offsetTop
      if (wrapperYOffset < clientY) {
        const transformY = Math.round(clientY - wrapperYOffset)
        this.swipeStyles = { transform: `translate3d(0px, ${transformY}px, 0)`, willChange: 'transform' }
        // this.swipeStyles = { transform: `translateY(${transformY}px)`, willChange: 'transform' }
      }
    },
    // movedHandler (event) {
    //   this.swipePointZero = event.changedTouches[0].clientY
    // },
    endHandler (event) {
      const clientY = event.changedTouches[0].clientY
      if (clientY - this.swipePointZero > 70) {
        this.$emit('close')
        this.swipeStyles = {}
      } else {
        this.swipeStyles = { transition: 'transform 0.2s ease-in-out', transform: 'translate3d(0px, 0px, 0)' }
        // this.swipeStyles = { transition: 'transform 0.2s ease-in-out', transform: `translateY(0px)` }
      }
    },
  },
}
